import { odooSyncRoutes } from './odoo-sync';
import { llmConfigRoutes } from './llm-config';

export const integrationsRoutes = [
  {
    path: 'integrations',
    children: [...odooSyncRoutes, ...llmConfigRoutes],
  },
];
